export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5.756c1db9.png";